import { ApiError, csrfHeaders, type Problem } from "@wilco/api";

/*
 * Запрос к REST, которого нет в contracts/openapi.json (маршрут изделия):
 * те же правила, что у openapi-fetch в @wilco/api. Cookie сессии, CSRF на
 * изменяющих, ошибка problem+json в ApiError. Когда маршрут войдёт в
 * контракт, производство перейдёт на api.GET и api.POST, а этот файл уйдёт.
 */
export async function rest<T>(method: "GET" | "POST" | "PATCH", url: string, body?: unknown): Promise<T> {
  const res = await fetch(url, {
    method,
    credentials: "same-origin",
    headers: {
      Accept: "application/json, application/problem+json",
      ...(body === undefined ? {} : { "Content-Type": "application/json" }),
      ...csrfHeaders(method),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (!res.ok) {
    const problem = res.headers.get("Content-Type")?.includes("json") ? ((await res.json()) as Problem) : undefined;
    throw new ApiError(res.status, problem);
  }
  return (await res.json()) as T;
}

/** Код правила из ответа сервера: по нему экран решает, спросить ли подтверждение. */
export function problemCode(e: unknown): string | undefined {
  return e instanceof ApiError ? e.problem?.code : undefined;
}
